import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const PartnerProfile = lazy(() => import("@/pages/partner/PartnerProfile"));

export const Route = createFileRoute("/partner/profil")({
  head: () => ({
    meta: [
      { title: "Företagsprofil – Partnerportal" },
      { name: "description", content: "Hantera era partneruppgifter hos Elmarknad.se." },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: () => <PartnerProfile />,
});
